import type { FC, PropsWithChildren, Dispatch, SetStateAction } from "react"
import { useMemo } from "react"
import { MapContainer, TileLayer, type MapContainerProps } from "react-leaflet"
import "leaflet/dist/leaflet.css"

type MapComponent = FC<
  PropsWithChildren<
    MapContainerProps & {
      setMap?: Dispatch<SetStateAction<L.Map | null>>
    }
  >
>

const Map: MapComponent = ({ children, setMap, ...props }) => {
  const containerProps: MapContainerProps = useMemo(
    () => ({
      // attributionControl: false,
      center: [-34.829206, 146.201805],
      zoom: 4,
      scrollWheelZoom: false,
      style: {
        width: "100%",
        height: "100%",
      },
      ...props,
    }),
    [props]
  )

  return (
    <MapContainer ref={setMap} {...containerProps}>
      {/* <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
        subdomains={"abcd"}
        maxZoom={22}
      /> */}
      <TileLayer
        attribution='<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> | <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
        url="https://api.maptiler.com/maps/67b411ea-7fca-427b-8eb0-872c15746a75/{z}/{x}/{y}.png?key={accessToken}"
        maxZoom={22}
        minZoom={1}
        zoomOffset={-1}
        tileSize={512}
        crossOrigin={true}
        accessToken="7Rv1LAVODnwl3SKBYp3I"
      />
      {children}
    </MapContainer>
  )
}
export default Map
